import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { ConnectedProps, connect } from "react-redux";
import { ApplicationState } from "../store";
import { actions } from "./../store/AddOn";
import AddOn from "./Addon";
import Title from "./Title";

const useStyles = makeStyles(() => ({
  box: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    flexGrow: 2,
    flexWrap: "wrap",
    justifyContent: "center",
  },
}));

const AddOns: React.FC<AddOnProps> = (props: AddOnProps) => {
  const classes = useStyles();

  const visibleAddons = props.addOns?.filter(i => i.visible);

  if (!((visibleAddons?.length ?? 0) > 0)) {
    return null;
  }

  return (
    <div id='ws-addon'>
      <Title title={props.title}></Title>
      <div className={classes.box}>
        {props.addOns?.map(
          (i, key) =>
            i.visible && (
              <AddOn
                key={key}
                checkMark={i.checkMark}
                texts={i.texts}
                Checked={i.Checked}
                popupProps={i.PopupState}
                uspProps={i.UspState}
                InternalCode={i.InternalCode}
                addOnChanged={props.addonChanged}
                disabled={i.disabled}
                lowMillageChanged={props.lowMillageChanged}
                includedWith={i.includedWith}
              />
            ),
        )}
      </div>
    </div>
  );
};
const connector = connect((state: ApplicationState) => state.addon, {
  addonChanged: actions.addonChanged,
  lowMillageChanged: actions.lowMillageValueChanged,
});

type AddOnProps = ConnectedProps<typeof connector> & {};

export default connector(AddOns);
